import { IconPhone } from '@bridebook/ui/src/icons';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import componentStyles from './call-button.style';

const CallButton = () => {
  const styles = componentStyles();
  return (
    <SignupLink
      clickedLocation="supplierProfile"
      clickedSection="stickyBottomBar"
      cta="phone"
      style={styles.link}>
      <IconPhone width={23} color="indigoCrush" style={styles.callButton} />
    </SignupLink>
  );
};
export default CallButton;
